/** @jsxImportSource react */
import { useSelector } from 'react-redux'
import { selectIsTenantAdmin } from '../../store/slices/tenantSlice'
import EmptyState from './EmptyState'

/** UI guard only; the backend enforces TENANT_ADMIN on every write anyway. */
const AdminRoute = ({ children }) => {
  const isAdmin = useSelector(selectIsTenantAdmin)
  if (!isAdmin) {
    return <EmptyState title="Admins only" description="Ask a tenant admin for access to this page." />
  }
  return children
}

export default AdminRoute
